import React from 'react';

/**
 * LocationSelector
 * A stateless button that displays the current delivery location label
 * and calls onChange() when clicked — the parent (Header) passes
 * openLocationModal as the onChange handler.
 */
const LocationSelector = ({ value, onChange, disabled = false }) => {
  const hasLocation = value && value !== 'Set Location';

  return (
    <button
      type="button"
      id="location-selector-btn"
      onClick={() => onChange?.()}
      disabled={disabled}
      title={disabled ? "Delivery location follows your default address" : "Change delivery location"}
      aria-label={disabled ? `Deliver to ${value}; change your default address to update location` : "Change delivery location"}
      className={[
        'flex min-w-[160px] items-center gap-2.5 rounded-2xl px-4 py-2.5 text-left transition-all duration-200',
        disabled
          ? 'bg-gray-50 cursor-not-allowed'
          : 'bg-gray-50 hover:bg-white hover:shadow-md hover:ring-1 hover:ring-gray-200',
      ].join(' ')}
    >
      {/* Icon */}
      <div className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-xl transition-colors duration-200 ${hasLocation ? 'bg-primary-600 text-white' : 'bg-primary-100 text-primary-600'}`}>
        <svg className="h-[18px] w-[18px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17.657 16.657 13.414 20.9a2 2 0 0 1-2.828 0l-4.243-4.243a8 8 0 1 1 11.314 0Z" />
          <circle cx="12" cy="11" r="3" />
        </svg>
      </div>

      {/* Label */}
      <div className="flex flex-col leading-none">
        <span className="text-[10px] font-bold uppercase tracking-[0.15em] text-primary-600">
          Deliver to
        </span>
        <span className={`mt-0.5 max-w-[120px] truncate text-sm font-bold ${hasLocation ? 'text-gray-800' : 'text-primary-600 animate-pulse'}`}>
          {value || 'Set Location'}
        </span>
      </div>

      {/* Chevron */}
      <svg className="ml-auto h-4 w-4 shrink-0 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
        <polyline points="6 9 12 15 18 9" />
      </svg>
    </button>
  );
};

export default LocationSelector;
